<template>
    <div class="body">
      <iframe
        class="content-box"
        :src="url"
        frameborder="0">
      </iframe>
    </div>
</template>

<script>
	export default {
	    data(){
        return{
          url:""
        }
		},
    mounted() {
      // if(this.$route.query.iscn == '1'){
      //   // 合规版
      //   if(this.$route.query.inviter){
      //     this.url="https://dapp.joymall.ai/?inviter="+this.$route.query.inviter + '&lang=' +  'zh-CN'
      //   }else{
      //     this.url="https://dapp.joymall.ai/?lang="+ 'zh-CN'
      //   }
      // }else{
      //   if(this.$route.query.inviter){
      //     this.url="https://dapp.joymall.ai/?inviter="+this.$route.query.inviter + '&lang=' +  'zh-CN'
      //   }else{
      //     this.url="https://dapp.joymall.ai/?lang="+ 'zh-CN'
      //   }
      // }
      if(this.$route.query.iscn == '1'){
        // 合规版
        if(this.$route.query.inviter){
          this.url="https://cn.neco.ltd/?inviter="+this.$route.query.inviter + '&lang=' + 'zh-CN'
        }else{
          this.url="https://cn.neco.ltd/?lang="+ 'zh-CN'
        }
      }else{
        if(this.$route.query.inviter){
          this.url="https://web.neco.ltd/?inviter="+this.$route.query.inviter + '&lang=' +  'zh-CN'
        }else{
          this.url="https://web.neco.ltd/?lang=" + 'zh-CN'
        }
      }

    },
  }
</script>

<style scoped>
.body{
  width: 100%;
  height: 100%;
  display: flex;
  background: #F2F4F6;
  align-items: center;
  min-width: 1366px;
}
.content-box{
  width: 375px;
  height: 100vh;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Lobby/index.vue